import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProPodcast.css';

const ProPodcast: React.FC<any> = ({ podcasts }) => {
  const navigate = useNavigate();

  const navigateToPodcastPage = () => {
    navigate('/Podcasts');
  };

  return (
    <div className='proPodcast-container'>
      <div className='proPodcast-main'>
        <div className='hedImg'>
          <div className='hedImgh1'>Podcast</div>
        </div>
        <div>
          {podcasts.map((podcast, index) => (
            <div key={index} className='title-play'>
              <div className='podcast-play-container'>
                <div className='proPodTtitle'>{podcast.title}</div>
                <div className='proPodDuration'>
                  {podcast.duration?.replace('.', ':')}
                </div>
              </div>
              <div
                style={{ cursor: 'pointer' }}
                onClick={navigateToPodcastPage}
              >
                <img
                  src='./assets/play.svg'
                  alt='play'
                  className='playButton'
                />
              </div>
            </div>
          ))}
        </div>
        <div onClick={navigateToPodcastPage} className='podcast-list-button'>
          <button style={{ padding: 0 }}>{'See Full List'}</button>
          <img
            src='./assets/arrow-right.svg'
            alt='listArrow'
            className='listArrowBtn'
          />
        </div>
      </div>
    </div>
  );
};

export default ProPodcast;
